import React, { useEffect, useState, useRef, useCallback } from 'react';

import Button from 'jd-library/Button';
import MorePopover from 'jd-library/MorePopover';

import {fetchAuditUrl, rewriteUrlForLocal} from '../../utills';

export const AuditButton = props => {
    const isCorrector = props.isCorrector
    
    const [startPopoverRef, setStartPopoverRef] = React.useState('');
    const [audiBtnLoader,updateAudiBtnLoader] = useState(false);
    
    const auditStats = props.auditStats;
     
    const auditQueuetList = isCorrector
      ? [
          {
            key: "20",
            label: "Correction Queue",
            className: auditStats.correctorQueueCount
              ? "star-item-list"
              : "star-item-list disable-item",
          },
        ]
      : [
          {
            key: "1",
            label: "Owner LTBM Product Audit Queue",
            className: auditStats.nonrelevanceQueueDocIdCount
              ? "star-item-list"
              : "star-item-list disable-item",
          },
          {
            key: "2",
            label: "Owner LTBM Service Audit Queue",
            className: auditStats.nonrelevanceServiceQueueDocIdCount
              ? "star-item-list"
              : "star-item-list disable-item",
          },
          {
            key: "3",
            label: "Onboarding LTBM Product Audit Queue",
            className: auditStats.onboardEmpQueueDocIdCount
              ? "star-item-list"
              : "star-item-list disable-item",
          },
          {
            key: "14",
            label: "Onboarding LTBM Service Audit Queue",
            className: auditStats.onboardEmpServiceQueueCount
              ? "star-item-list"
              : "star-item-list disable-item",
          },
          {
            key: "4",
            label: "Contractor v1 LTBM Product Audit Queue",
            className: auditStats.contractorDocIdCount
              ? "star-item-list"
              : "star-item-list disable-item",
          },
          {
            key: "15",
            label: "Contractor v1 LTBM Service Audit Queue",
            className: auditStats.contractorServiceDocIdCount
              ? "star-item-list"
              : "star-item-list disable-item",
          },
          {
            key: "5",
            label: "Contractor v2 LTBM Product Audit Queue",
            className: auditStats.contractorV2DocIdCount
              ? "star-item-list"
              : "star-item-list disable-item",
          },
          {
            key: "16",
            label: "Contractor v2 LTBM Service Audit Queue",
            className: auditStats.contractorV2ServiceDocIdCount
              ? "star-item-list"
              : "star-item-list disable-item",
          },
          {
            key: "6",
            label: "Paid Objectionable Product Audit Queue",
            className: auditStats.objectionableDocIdPaidCount
              ? "star-item-list marginB10"
              : "star-item-list marginB10 disable-item",
          },
          {
            key: "7",
            label: "Non-paid Objectionable Product Audit Queue",
            className: auditStats.objectionableDocIdFreeCount
              ? "star-item-list marginB10"
              : "star-item-list marginB10 disable-item",
          },
          {
            key: "8",
            label: "Paid Objectionable Service Audit Queue",
            className: auditStats.paidObjectionalServiceDocIdCount
              ? "star-item-list"
              : "star-item-list disable-item",
          },
          {
            key: "9",
            label: "Non-paid Objectionable Service Audit Queue",
            className: auditStats.nonpaidObjectionalServiceDocIdCount
              ? "star-item-list"
              : "star-item-list disable-item",
          },
          /*
        {
            key: '1', 
            label: 'Regular Audit Queue',
            className: auditStats.regularDocIdCount ? 'star-item-list' : 'star-item-list disable-item'
        },{
            key: '14', 
            label: 'Paid Regular Service Queue',
            className: auditStats.paidRegularServiceCount ? 'star-item-list' : 'star-item-list disable-item'
        },{
            key: '15', 
            label: 'Non-Paid Regular Service Queue',
            className: auditStats.nonpaidRegularServiceCount ? 'star-item-list' : 'star-item-list disable-item'
        },{
            key: '11', 
            label: 'Marketplace Audit Queue',
            className: auditStats.customSellonlineDocIdCount ? 'star-item-list' : 'star-item-list disable-item'
        },{
            key: '10', 
            label: 'Branded Product Audit Queue',
            className: auditStats.regularBrandDocIdCount ? 'star-item-list' : 'star-item-list disable-item' 
        },{
            key: '16', 
            label: 'Paid Restricted Service Category Queue',
            className: auditStats.paidRestrictedServiceCount ? 'star-item-list' : 'star-item-list disable-item'
        },{
            key: '17', 
            label: 'Non-Paid Restricted Service Category Queue',
            className: auditStats.nonpaidRestrictedServiceCount ? 'star-item-list' : 'star-item-list disable-item'
        },{
            key: '2', 
            label: 'Furlough Audit Queue',
            className: auditStats.furloughDocIdCount ? 'star-item-list' : 'star-item-list disable-item'
        },{
            key: '5', 
            label: 'Contractor v3 Audit Queue',
            className: auditStats.contractorV3DocIdCount ? 'star-item-list' : 'star-item-list disable-item'
        },{
            key: '6', 
            label: 'DB Audit Queue',
            className: auditStats.dbQueueDocIdCount ? 'star-item-list' : 'star-item-list disable-item' 
        },{
            key:'13',
            label: 'MRP Compliance Queue',
            className: auditStats.regularBrandMrpDocIdCount ? 'star-item-list marginB10' : 'star-item-list marginB10 disable-item'
        }
        */
        ];
    
    const startOptionClick = (obj) => {
        let queueType = 'nonRelevanceQueue';
        
        if(obj.key == '1') {
            queueType = 'nonRelevanceQueue';
            obj.queueType = 'nonrelevanceQueueDocIdCount';
            if(!auditStats.nonrelevanceQueueDocIdCount) return;
        } else if(obj.key == '2') {
            queueType = 'nonRelevanceServiceQueue';
            obj.queueType = 'nonrelevanceServiceQueueDocIdCount';
            if(!auditStats.nonrelevanceServiceQueueDocIdCount) return;
        } else if(obj.key == '3') {
            queueType = 'onboardEmpQueue';
            obj.queueType = 'onboardEmpQueueDocIdCount';
            if(!auditStats.onboardEmpQueueDocIdCount) return;
        }else if (obj.key == '14'){
            queueType = 'onboardEmpServiceQueue';
            obj.queueType = 'onboardEmpServiceQueueDocidCount';
            if(!auditStats.onboardEmpServiceQueueDocidCount) return;
        } else if(obj.key == '4') {
            queueType = 'contractor';
            obj.queueType = 'contractorDocIdCount';
            if(!auditStats.contractorDocIdCount) return;
        }else if (obj.key == '15'){
            queueType = 'contractorServiceQueue';
            obj.queueType = 'contractorServiceDocIdCount';
            if(!auditStats.contractorServiceDocIdCount) return;
        }else if(obj.key == '5') {
            queueType = 'contractorv2';
            obj.queueType == 'contractorV2DocIdCount';
            if(!auditStats.contractorV2DocIdCount) return;
        }else if (obj.key == '16'){
            queueType = 'contractorv2ServiceQueue';
            obj.queueType = 'contractorV2ServiceDocIdCount';
            if(!auditStats.contractorV2ServiceDocIdCount) return;
        }else if(obj.key == '6') {
            queueType = 'objectionPaid';
            obj.queueType = 'objectionableDocIdPaidCount'
            if(!auditStats.objectionableDocIdPaidCount) return;
        } else if(obj.key == '7') {
            queueType = 'objectionFree';
            obj.queueType =  'objectionableDocIdFreeCount'
            if(!auditStats.objectionableDocIdFreeCount)  return;
        } else if(obj.key == '8') {
            queueType = 'paidObjectionalService';
            obj.queueType =  'paidObjectionalServiceDocIdCount'
            if(!auditStats.paidObjectionalServiceDocIdCount) return;
        } else if(obj.key == '9') {
            queueType = 'nonpaidObjectionalService';
            obj.queueType = 'nonpaidObjectionalServiceDocIdCount'
            if(!auditStats.nonpaidObjectionalServiceDocIdCount) return;
        }else if (obj.key == '20'){
            queueType = 'corrector';
            if(!auditStats.correctorQueueCount) {
                return;
            }
        }
        
        /*if(obj.key == '17'){
            queueType = 'nonpaidRestrictedService';
            if(!auditStats.nonpaidRestrictedServiceCount) {
                return;
            }
        } else if(obj.key == '16'){
            queueType = 'paidRestrictedService';
            if(!auditStats.paidRestrictedServiceCount) {
                return;
            }
        } else if(obj.key == '15'){
            queueType = 'nonpaidRegularService';
            if(!auditStats.nonpaidRegularServiceCount) {
                return;
            }
        } else if(obj.key == '14'){
            queueType = 'paidRegularService';
            if(!auditStats.paidRegularServiceCount) {
                return;
            }
        } else if(obj.key == '13'){
            queueType = 'brandedMrp';
            if(!auditStats.regularBrandMrpCount && !auditStats.regularBrandMrpDocIdCount) {
                return;
            }
        }else if(obj.key == '12'){
            queueType = 'brandedCqueue';
            if(!auditStats.regularBrandCqueueDocIdCount && !auditStats.regularBrandCqueueCount) {
                return;
            }
        }else if(obj.key == '11'){
            queueType = 'customSellonline';
            if(!auditStats.regularBrandDocIdCount && !auditStats.regularBrandCount) {
                return;
            }
        }else if(obj.key == '10'){
            queueType = 'branded';
            if(!auditStats.regularBrandDocIdCount && !auditStats.regularBrandCount) {
                return;
            }
        }else 
        if(obj.key == '6'){
            queueType = 'dbQueue';
            if(!auditStats.dbQueueDocIdCount){
                return;
            }
        }
        if(obj.key == '5'){
            queueType = 'contractorv3';
            if(!auditStats.contractorV3DocIdCount){
                return;
            }
        }        
        if(obj.key == '2') {
            queueType = 'furlough';
            if(!auditStats.furloughDocIdCount) {
                return;
            }
        } else */
        updateAudiBtnLoader(true);
        fetchAuditUrl({
            queueType,
            cb: (data) => {
                if(data.data.status == 1) {
                    if(window.top != window.self) {
                        data.data.url += '&loadedInIframe=true';
                    }
                    if(["objectionPaid", "objectionFree", "nonpaidObjectionalService", "paidObjectionalService"].includes(queueType) &&
                    data.data.url.toLowerCase().indexOf('isobjection=true')===-1) {
                        data.data.url += "&isObjection=true";
                    }
                    window.location.href = rewriteUrlForLocal(data.data.url);
                } else {
                    let showMsg = "No Products/Services Found.";
                    if(data.data?.msg) {
                        showMsg = data.data.msg;
                    } 
                    props.onStatEmpty(obj.queueType);
                    alert(showMsg);
                }
                updateAudiBtnLoader(false);
            }
        });
	}

    const fetchCorrectProductUrl = () => {
        let queueType = 'corrector';
        updateAudiBtnLoader(true);
        fetchAuditUrl({
            queueType,
            cb: (data) => {
                if(data.data.status == 1) {
                    if(window.top != window.self) {
                        data.data.url += '&loadedInIframe=true';
                    }
                    if(["objectionPaid", "objectionFree", "nonpaidObjectionalService", "paidObjectionalService"].includes(queueType) &&
                    data.data.url.toLowerCase().indexOf('isobjection=true')===-1) {
                        data.data.url += "&isObjection=true";
                    }
                    window.location.href = rewriteUrlForLocal(data.data.url);
                } else {
                    let showMsg = "No Products/Services Found.";
                    if(data.data?.msg) {
                        showMsg = data.data.msg;
                    } 
                    alert(showMsg);
                }
                updateAudiBtnLoader(false);
            }
        });
        
    }
    
    const showActiveButtonCond = auditStats.nonrelevanceQueueDocIdCount ||
    auditStats.nonrelevanceServiceQueueDocIdCount || auditStats.onboardEmpQueueDocIdCount || auditStats.contractorDocIdCount || auditStats.contractorV2DocIdCount || auditStats.objectionableDocIdPaidCount || auditStats.objectionableDocIdFreeCount || auditStats.paidObjectionalServiceDocIdCount || auditStats.nonpaidObjectionalServiceDocIdCount /*
    || auditStats.furloughDocIdCount || auditStats.regularDocIdCount || auditStats.regularCount || auditStats.regularBrandCount ||   auditStats.contractorV3DocIdCount || auditStats.onboardEmpQueueCount || auditStats.regularBrandDocIdCount || auditStats.regularCustomDocIdCount || auditStats.regularBrandCqueueDocIdCount || auditStats.regularBrandMrpDocIdCount || auditStats.paidRegularServiceCount || auditStats.nonpaidRegularServiceCount || auditStats.paidRestrictedServiceCount || auditStats.nonpaidRestrictedServiceCount || auditStats.paidObjectionalServiceCount || auditStats.nonpaidObjectionalServiceCount */;
    
    return isCorrector ? (
        <Button
          className={"action-btn disabled-btn"}
          showLoader={audiBtnLoader}
          size="lg"
          block
          onClick={isCorrector ? fetchCorrectProductUrl : null}
        >
          {`Start ${isCorrector ? "Correcting" : "Auditing"} Now`}
        </Button>
      ) : showActiveButtonCond ? (
        <div
          style={{ position: "relative", textAlign: "center", width: "100%" }}
          className={"start-now-btn"}
          ref={(r) => setStartPopoverRef(r)}
        >
          <MorePopover
            list={auditQueuetList}
            onOptionClick={startOptionClick}
            containerRef={startPopoverRef}
            style={{ width: "100%" }}
            fixToBottom={true}
            eventType="click"
            className={"start-audit-popup"}
          >
            <Button
              className={"action-btn"}
              showLoader={audiBtnLoader}
              size="lg"
              block
            >
              Start Auditing Now
            </Button>
          </MorePopover>
        </div>
      ) : null;  
}